import { type RichiestaDTO } from '@framework/api-client/api/inquiries-compile/schemas/richiestaDTO.ts';
import { type ColumnsType } from 'antd/es/table';
import { SubmissionViewTableButton } from '../../../submission/components/SubmissionViewTableButton.tsx';
import { submissionsColumns } from '../../../submission/submissionsColumns.tsx';

/**
 * Colonne della tabella delle richieste presentate nella pratica:
 * colonne comuni delle richieste + link al dettaglio.
 */
export const dossierSubmissionsColumns: ColumnsType<RichiestaDTO> = [
  ...submissionsColumns,
  {
    key: 'actions',
    align: 'right',
    render: (_, record) => (
      <SubmissionViewTableButton submissionId={record.id} />
    ),
  },
];
